import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import {
  GitHubConnection,
  GithubIntegrationType,
} from "@reflag/shared/githubConnectionAPI";

export function useGithubSaveRepoMutation() {
  const { org } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    GitHubConnection,
    AxiosError<ErrorResponse>,
    GithubIntegrationType
  >({
    mutationFn: (data) =>
      api
        .post<"/orgs/:orgId/github/connection">(
          `/orgs/${org.id}/github/connection`,
          data,
        )
        .then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: integrationQueryKeys.githubConnection(org.id),
      });
    },
  });
}
